import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ReportMetadata, Approver, ReportAuditRecord, ReportStates } from '../../models/report.model';
import { ReportdashboardService } from '../../services/reportdashboard.service';
import { RequiredrptmetadataComponent } from '../requiredrptmetadata/requiredrptmetadata.component';
import { VoluntaryrptmetadataComponent } from '../voluntaryrptmetadata/voluntaryrptmetadata.component';
import { NotifierService } from 'angular-notifier';
import { ConfirmationService, SelectItem, LazyLoadEvent } from 'primeng/api';
import { ReportworkflowComponent } from '../reportworkflow/reportworkflow.component';
import { error } from 'util';
import { ReporthistoryComponent } from '../reporthistory/reporthistory.component';
import { PermissionsService } from '../../services/permissions.service';
import { ReportattachmentsComponent } from '../reportattachments/reportattachments.component';
import { LookupService } from '../../services/lookups/lookup.service';
import { AuthUserService } from '../../services/appInitialization/authUser.service';
import { User, HqLocationsModel } from '../../models/user.model';
import { ReportService } from '../../services/report.service';
//import { Observable } from 'rxjs';
//import { NgForm } from '@angular/forms';

//import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reportlisting',
  templateUrl: './reportlisting.component.html',
  styleUrls: ['./reportlisting.component.css'],
  providers: [ConfirmationService]
})
export class ReportlistingComponent implements OnInit,OnChanges {
  showLaunchButtonClick: boolean = false;
  showPublishedReportClick: boolean = false;
  displayMetadata = false;
  displayWorkflowDlg = false;
  displayHistoryDlg = false;
  displayAttachmentDlg = false;
  categories: SelectItem[];
  reportNames: SelectItem[];
  countries: SelectItem[];
  fasPosts: SelectItem[];
  programAreas: SelectItem[];
  distributionTypes: SelectItem[];
  dueDates: SelectItem[];
  reportStates: SelectItem[];
  dialogTitle: string;
  selectedReportID: string = '';
  lastUpdateDatetime: SelectItem[];
  publishedReportMetadata: ReportMetadata;
  //strRequiredReports="Required Reports";
  //strVoluntaryReports="Voluntary Reports";
  @Input() reportType: string;
  @ViewChild(RequiredrptmetadataComponent) requiredRptMetadata: RequiredrptmetadataComponent;
  @ViewChild(VoluntaryrptmetadataComponent) voluntaryRptMetadata: VoluntaryrptmetadataComponent;
  @ViewChild(ReportworkflowComponent) reportWorkflow: ReportworkflowComponent;
  @ViewChild(ReporthistoryComponent) reporthistory: ReporthistoryComponent;
  @ViewChild(ReportattachmentsComponent) reportAttachements: ReportattachmentsComponent;
  @Input() reportScheduleData: ReportMetadata[];
  @Output() refreshDataSource=new EventEmitter<boolean>();

  interestReportScheduleData: ReportMetadata[];
  myReportScheduleData: ReportMetadata[];
  currentUser: User;
  isRequired: boolean;
  reportId: any;
  loading:boolean;
  cols: any[];

  constructor(
    private lookupService: LookupService,
    private authUser: AuthUserService,
    private authUserService: AuthUserService,
    private reportDashboardService: ReportdashboardService,
    private workflowEvents: PermissionsService,
    private notifier: NotifierService,
    private confirmationService: ConfirmationService,
    private reportService:ReportService
  ) {}

  ngOnInit() {
   // this.currentUser = this.authUser._user;

    //console.log(this.reportType);
    // if (this.reportType == 'r' || this.reportType =='i') this.isRequired = true;
    // else if (this.reportType == 'v') this.isRequired = false;
    //  this.loading = true;
    this.LoadTableFilters(this.reportScheduleData);

  }

  ngOnChanges(changes:SimpleChanges)
  {
    this.LoadTableFilters(this.reportScheduleData);
  }
  LoadTableFilters(reportMetadata: ReportMetadata[]) {
    if(reportMetadata.length>0)
    {
    this.categories = this.GetUniqueValues(reportMetadata.map(r => r.category));
    this.reportNames = this.GetUniqueValues(reportMetadata.map(r => r.reportName));
    this.countries = this.GetUniqueValues(reportMetadata.map(r => r.country));
    this.fasPosts = this.GetUniqueValues(reportMetadata.map(r => r.fasPost));
    this.programAreas = this.GetUniqueValues(reportMetadata.map(r => r.programArea));
    this.distributionTypes = this.GetUniqueValues(reportMetadata.map(r => r.distribution));
    this.dueDates = this.dateSort(reportMetadata.map(r => r.dueDate));
    this.reportStates = this.GetUniqueValues(reportMetadata.map(r => r.reportState));
    this.lastUpdateDatetime = this.dateSort(reportMetadata.map(r => r.lastUpdatedDatetime));
    }

    if(this.reportType == 'v')
    {
      this.cols = [
        { field: 'category', header: 'Category' },
        { field: 'reportName', header: 'Report Name' },
        { field: 'country', header: 'Country' },
        { field: 'fasPost', header: 'FAS Post' },
        { field: 'distribution', header: 'Distribution' },
        { field: 'reportState', header: 'Status' },
        { field: 'dueDate', header: 'Due Date' },
        { field: 'lastUpdatedDatetime', header: 'Status Updated Date' },
      ];
    }

    if (this.reportType == 'r' || this.reportType =='i')
    {
      this.cols = [
        { field: 'category', header: 'Category' },
        { field: 'reportName', header: 'Frequency Type' },
        { field: 'country', header: 'Country' },
        { field: 'fasPost', header: 'FAS Post' },
        { field: 'programArea', header: 'Program Area' },
        { field: 'distribution', header: 'Distribution' },
        { field: 'reportState', header: 'Status' },
        { field: 'dueDate', header: 'Due Date' },
        { field: 'lastUpdatedDatetime', header: 'Status Updated Date' },
      ];
    }

  }

dateSort(filterItem: any[]): SelectItem[]{
    var returnArray = new Array<SelectItem>();
      for (let i = 0; i < filterItem.length; i++) {
        if (returnArray.filter(r => r.label == filterItem[i]).length == 0)
          returnArray.push({ label: filterItem[i], value: filterItem[i] });
      }
      returnArray.sort((a, b) => new Date(b.value).getTime() - new Date(a.value).getTime());
      return returnArray;
  }

  //LoadReportSchedules()
  //{
    //this.LoadTableFilters(this.reportScheduleData);

    // this.currentUser = this.authUser._user;

    // this.reportDashboardService.getReportSchedule().subscribe((data:ReportMetadata[])=>{
    //     //TODO: Push this data to Local storage in order to make edits avoid reloads
    //     this.myReportScheduleData =data;
    //     this.reportScheduleData =this.myReportScheduleData.filter(rs => rs.isRequired == this.isRequired);
    //     //console.log("Report Schedule data from MY Reports" + JSON.stringify(this.reportScheduleData));

    //     this.lookupService.getUserLocations().subscribe((userLocation: HqLocationsModel[]) => {
    //       if(this.currentUser.userType.typeName=='HQUser')
    //       {
    //         if(this.currentUser.userRoles[1].roleName == 'Admin')
    //         {
    //             if (this.reportType == 'r')
    //                 this.reportScheduleData = this.myReportScheduleData.filter(rs => rs.isRequired == true)

    //             this.reportScheduleData.sort((a,b):number=>{
    //                 if (a.reportState > b.reportState) return 1;
    //                 if (a.reportState < b.reportState) return -1;
    //                 return 0;
    //             });
    //         }
    //         else
    //         {
    //             if (this.reportType == 'r')
    //                   this.reportScheduleData = this.myReportScheduleData.filter(rs => rs.programArea == userLocation[0].programArea && rs.isRequired == true)
    //             if(this.reportType =='i')
    //                   this.reportScheduleData = this.myReportScheduleData.filter(rs => rs.programArea != userLocation[0].programArea && rs.isRequired == true)

    //             this.reportScheduleData.sort((a,b):number=>{
    //                 if (a.category > b.category) return 1;
    //                 if (a.category < b.category) return -1;
    //                 return 0;
    //             });
    //         }
    //       }
    //         // this.reportScheduleData.sort((a,b):number=>{
    //         //   if (a.category > b.category) return 1;
    //         //   if (a.category < b.category) return -1;
    //         //   return 0;
    //         // });
    //       this.LoadTableFilters(this.reportScheduleData);
    //       this.loading=false;
    //     });

    // });

  //}

  showMetadataDialog(id: any) {
    this.reportId = id;
    //console.log("in showMetadataDialog" + id);
    if (this.reportType == 'r' || this.reportType =='i') this.requiredRptMetadata.showMetadataDialog(this.reportId);
    else this.voluntaryRptMetadata.showMetadataDialog(this.reportId);
  }
  ShowHistoryDialog(id: any) {
    this.reporthistory.ShowReportHistoryDlg(id);
    this.displayHistoryDlg = true;
  }
  ShowAttachmentsDialog(id: any, reportState: string) {
    this.reportAttachements.ShowAttachmentsDialog(id, reportState);
    this.displayAttachmentDlg = true;
  }

  LaunchReport(id: any) {
    if (this.reportType == 'r' || this.reportType =='i') this.requiredRptMetadata.LaunchReport(id);
    else this.voluntaryRptMetadata.LaunchReport(id);
  }
  ViewPDF(id:any)
  {
    this.reportDashboardService.downloadPDF$(id).subscribe((content:Blob)=>{
          const fileURL = URL.createObjectURL(content);
          window.open(fileURL, '_blank');

        });

  }

  PreviewPDF(id:any)
  {
    this.reportService.previewPDF$(id).subscribe((content:Blob)=>{
          const fileURL = URL.createObjectURL(content);

          window.open(fileURL, '_blank');

        });

  }
  ShowHideDialog(isDisplayRefresh: number) {
    //0-Hide Popup No refresh 1-Show popup no refresh 2-Hide popup Refresh 3-Show popup Refresh
    this.displayMetadata = (isDisplayRefresh == 1 || isDisplayRefresh == 3);
    // console.log(isDisplayRefresh);
    this.refreshDataSource.emit((isDisplayRefresh == 2 || isDisplayRefresh == 3));
  }

  ShowHideWorkflowDialog(isDisplay: boolean) {
    //console.log(isDisplay);
    this.displayWorkflowDlg = isDisplay;
    if (isDisplay == false) this.refreshDataSource.emit(true);//this.LoadReportSchedules();

    //this.LoadReportSchedules();
  }
  ShowHideHistoryDlg(isDisplay: boolean) {
    this.displayHistoryDlg = isDisplay;
  }
  SendToWorkflow(reportSchedule: ReportMetadata, mode: string) {
    this.reportDashboardService.getReportScheduleById(reportSchedule.id).subscribe((data: ReportMetadata)=>{
          this.publishedReportMetadata = data;
          // console.log('Report Metadata ===========     '+ JSON.stringify(this.publishedReportMetadata));
          // console.log('Report Metadata ===========     '+ this.publishedReportMetadata.isReportPublished);

              if(this.publishedReportMetadata.isReportPublished)
              {
                this.showPublishedReportClick = true;
                this.notifier.notify('error', 'Report is Published. Please refresh the page.');
              }
              else{
                  this.reportWorkflow.ShowWorkflowDialog(reportSchedule.id, mode);
                  this.dialogTitle = this.reportWorkflow.dialogTitle;
              }
          });


    //console.log('In SendToWorkflow');
    //this.displayWorkflowDlg= true;
  }

  ShowConfirmationDlg(id: any, dlgMessage: string, action: string, successMsg: string) {
    this.confirmationService.confirm({
      message: dlgMessage,
      header: 'Confirmation',
      icon: 'fa fa-exclamation-circle',
      accept: () => {
        this.reportDashboardService.performAction$(id, action).subscribe(
          resp => {
            if (resp.ok) {
              // console.log("Test the load");
              //this.LoadReportSchedules();
              this.refreshDataSource.emit(true);
              this.notifier.notify('success', successMsg);
            }
            // else {
            // this.notifier.notify('error', 'Report is already Published. Please refresh the page.');
            // }
          },
          err => {
            console.log(err);
            this.notifier.notify('error', 'Something went wrong, Please contact Administrator');
          }
        );
      }
    });
  }

  GetStyle(reportState: string): string {
    let colorVal = '#FFF';
    var value: string[] = [reportState, 'ViewDisabledRecord'];
    this.workflowEvents.checkAuthorization(value).subscribe(authorized => {
      //console.log(authorized);
      if (authorized) {
        colorVal = '#EDEDED';
      }
    });
    return colorVal;
  }

  SendToPostApprover(report: any) {
    if(report.reportStateId == ReportStates.RequestedForCorrection)
    {
      this.ShowConfirmationDlg(
        report.id,
        'Are you sure you want to send for Approval?',
        'SendCorrectedToPostApprover',
        'Report Sent to Approver Successfully'
      );
    }
    else{
        this.ShowConfirmationDlg(
          report.id,
          'Are you sure you want to send for Approval?',
          'SendToPostApprover',
          'Report Sent to Approver Successfully'
        );
    }
  }

  PutOnHold(id: any) {
      this.reportDashboardService.getReportScheduleById(id).subscribe((data: ReportMetadata)=>{
        this.publishedReportMetadata = data;
        // console.log('Report Metadata ===========     '+ JSON.stringify(this.publishedReportMetadata));
        // console.log('Report Metadata ===========     '+ this.publishedReportMetadata.isReportPublished);

            if(this.publishedReportMetadata.isReportPublished)
            {
              this.showPublishedReportClick = true;
              this.notifier.notify('error', 'Report is Published. Please refresh the page.');
            }
            else{
                this.ShowConfirmationDlg(id, 'Are you sure you want to Put report on hold?', 'PutOnHold', 'Report is Put on Hold');
            }
        });
  }

  UnHoldReport(id: any) {
    this.ShowConfirmationDlg(
      id,
      'Are you sure you want to remove Hold on report?',
      'UnHoldReport',
      'Report is removed from Hold'
    );
  }
  PublishImmediately(id: any) {
    this.reportDashboardService.getReportScheduleById(id).subscribe((data: ReportMetadata)=>{
          this.publishedReportMetadata = data;
              if(this.publishedReportMetadata.isReportPublished)
              {
                this.showPublishedReportClick = true;
                this.notifier.notify('error', 'Report is Published. Please refresh the page.');
              }
              else{
                  this.ShowConfirmationDlg(
                    id,
                    'Are you sure you want to Publish Immediately?',
                    'PublishImmediately',
                    'Report is send to Publish Immediately'
                  );
                }
    });
  }

DeleteReport(id: any){
    this.ShowConfirmationDlg(
      id,
      'Are you sure you want to delete the report?',
      'DeleteReport',
      'Report is Deleted'
    );

}
  //TODO: Move this to a generic utils class
  GetUniqueValues(vals: any[]): SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      if (returnArry.filter(r => r.label == vals[cnt]).length == 0)
        returnArry.push({ label: vals[cnt], value: vals[cnt] });
    }
    //console.log(returnArry.length);

    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }



  loadCarsLazy(event: LazyLoadEvent) {
    this.loading = true;

    //in a real application, make a remote request to load data using state metadata from event
    //event.first = First row offset
    //event.rows = Number of rows per page
    //event.sortField = Field name to sort with
    //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
    //filters: FilterMetadata object having field as key and filter value, filter matchMode as value

    //imitate db connection over a network
    setTimeout(() => {
          if(this.reportScheduleData.length >0)
          {
            this.loading = false;
          }

    }, 1000);
}

// OnClassifiedOkButton()
  // {
  //   this.showLaunchButtonClick = false;
  //   this.LaunchReport(this.selectedReportID);
  //   console.log("on Ok");

  // }
  // OnLaunchReportAlertClassified(id: any)
  // {
  //   this.showLaunchButtonClick = true;
  //   this.selectedReportID = id;
  //   console.log("on launch");
  // }

  OnshowPublishedReportOkButton()
  {
    this.showPublishedReportClick = false;
  }
}
